import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/auth.store'
import { Loader2 } from 'lucide-react'
import './AuthCallback.scss'

export function AuthCallback() {
  const navigate = useNavigate()
  const { initialize } = useAuthStore()

  useEffect(() => {
    const handleCallback = async () => {
      await initialize()
      navigate('/', { replace: true })
    }

    handleCallback()
  }, [initialize, navigate])

  return (
    <div className="auth-callback">
      <Loader2 className="spinner" size={32} />
      <p>Signing you in...</p>
    </div>
  )
}
